import _omit                       from 'lodash/omit';
import { LATEST_FORMAT_VERSION }   from '@tokamap/core';
import { Shape }                   from '@tokamap/core';
import { featureTypeOfShape }      from '@/TokamapEditor/helpers/featureTypes';
import { shapeToLatestRawFeature } from '@tokamap/core';

/** Ce que l'API stocke, refait depuis un document publié. À part pour se tester sans l'éditeur. */

/**
 * Les attributs d'une `Feature` tels que l'éditeur les écrit lui-même (voir `onSave` dans
 * `TokamapEditor/index.tsx`). Le `properties.id` du document est laissé de côté : les formes
 * recréées reçoivent de nouveaux identifiants.
 */
export function featureAttributes(shape: Shape, mapUrn: Urn, placeIds: Set<string>) {
	const rawFeature = shapeToLatestRawFeature(shape);
	const entityId = (rawFeature.geometry.properties?.entity as any)?.entity?.id;

	return {
		coordinates: rawFeature.geometry.coordinates,
		extra: rawFeature.geometry.properties?.extra,
		featureType: featureTypeOfShape(shape).urn,
		layer: shape.layer?.toString(),
		map: mapUrn,
		// Seulement si le point d'intérêt existe encore : une urn morte ferait échouer tout le lot.
		entityUrn: entityId !== undefined && placeIds.has(String(entityId))
			? `$:map:place:${entityId}`
			: null,
		theme: shape.themeId ? `$:map:theme:${shape.themeId}` : null,
	};
}

/**
 * La configuration de carte que porte un document publié. `themes` en est retiré — la publication
 * l'embarque dans le document, mais les thèmes vivent au niveau du projet (`themeStore`) — et
 * `formatVersion` suit le format dans lequel `shapeToLatestRawFeature` réécrit les formes.
 *
 * `null` sans `configurations` : écrire une configuration vide effacerait le cadrage de la carte.
 */
export function restoredConfiguration(document: unknown) {
	const configurations = (document as { configurations?: Record<string, unknown> } | null)?.configurations;

	if (!configurations) return null;

	return { ..._omit(configurations, ['themes']), formatVersion: LATEST_FORMAT_VERSION };
}
